import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, inject, Input, OnInit, signal } from '@angular/core';
import {  map, take, timer } from 'rxjs';
import { ModalComponent } from "../modal";
import { TimerService } from './service/timer.service';
import { gsap } from 'gsap';


@Component({
  selector: 'shared-timer',
  imports: [CommonModule, ModalComponent],
  templateUrl: './timer.component.html',
  styleUrl: './timer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimerComponent implements OnInit {


timerService=inject(TimerService);

  @Input() isOpen = false;

  @Input() endTimer = 0;
  cronometro = signal(0);
  @ViewChild('digitsRef') digitsRef?: ElementRef<HTMLElement>;
  @ViewChild('floatRef') floatRef?: ElementRef<HTMLElement>;
  private alertTimeline?: gsap.core.Timeline;

  ngOnInit(): void {
    this.loadTimer();
  }

  loadTimer() {
    // Determinar punto de inicio: reanudar desde localStorage o iniciar nuevo
    const persistedRemaining = this.timerService.getRemainingSeconds();
    let startFrom = 0;

    if (persistedRemaining > 0) {
      startFrom = persistedRemaining;
      this.timerService.updateRemaining(startFrom);
    } else if (this.endTimer > 0) {
      startFrom = this.timerService.start(this.endTimer);
      this.timerService.updateRemaining(startFrom);
    } else {
      return;
    }

    timer(0, 1000).pipe(
      map((i) => startFrom - i),
      take(startFrom + 1) // incluye el 0 al final
    ).subscribe((v) => {
      this.cronometro.set(v);
      this.timerService.updateRemaining(v);
      if (v === 0) {
        this.timerService.complete();
        this.startAlertAnimation();
      }
    });
  }

  openModal(){
    this.isOpen=true;
  }

  closeModal(){
    this.isOpen=false;
  }

  formatTime(totalSeconds: number): string {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  private pad(n: number): string {
    return n < 10 ? `0${n}` : `${n}`;
  }
  private startAlertAnimation(): void {
    this.alertTimeline?.kill();
    const targets: HTMLElement[] = [];
    if (this.digitsRef?.nativeElement) targets.push(this.digitsRef.nativeElement);
    if (this.floatRef?.nativeElement) targets.push(this.floatRef.nativeElement);
    if (targets.length === 0) return;
    const tl = gsap.timeline({ repeat: -1, yoyo: true });
    tl.to(targets, {
      backgroundColor: '#dc2626',
      color: '#ffffff',
      scale: 1.06,
      boxShadow: '0 0 18px #dc2626',
      duration: 0.6,
      ease: 'power1.inOut'
    }).to(targets, {
      backgroundColor: '#991b1b',
      boxShadow: '0 0 8px #991b1b',
      scale: 1.0,
      duration: 0.6,
      ease: 'power1.inOut'
    });
    this.alertTimeline = tl;
  }

}
